import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { CalendarClock } from "lucide-react";

/** Renders a 21-day free-trial banner using agency.trial_ends_at.
 *  Service member version (`compact`) is slim; admin version (default) is fuller. */
export const TrialBanner = ({ compact = false }) => {
  const [agency, setAgency] = useState(null);

  useEffect(() => {
    api.get("/auth/agency-trial").then(r => setAgency(r.data)).catch(() => {});
  }, []);

  if (!agency?.trial_ends_at || !(agency?.access_status || "").startsWith("trial")) return null;

  const end = new Date(agency.trial_ends_at);
  const daysLeft = Math.max(0, Math.ceil((end - new Date()) / 86400000));
  const expired = daysLeft <= 0;

  if (compact) {
    return (
      <div
        data-testid="trial-banner-compact"
        className="mb-4 flex items-center gap-2 rounded-md border px-3 py-2 text-xs"
        style={{ borderColor: "hsl(var(--haruki-leaf))", color: "hsl(var(--haruki-leaf))" }}
      >
        <CalendarClock className="h-3.5 w-3.5" />
        <span>{expired ? "Trial ended" : `${daysLeft} day${daysLeft === 1 ? "" : "s"} left in free trial`}</span>
      </div>
    );
  }

  return (
    <div
      data-testid="trial-banner"
      className="mb-8 flex flex-wrap items-center justify-between gap-3 rounded-md border px-4 py-3"
      style={{ borderColor: "hsl(var(--haruki-leaf))", background: "hsl(var(--haruki-leaf) / 0.08)" }}
    >
      <div className="flex items-center gap-3">
        <CalendarClock className="h-4 w-4" style={{ color: "hsl(var(--haruki-leaf-deep))" }} />
        <div>
          <div className="text-xs font-semibold uppercase tracking-widest" style={{ color: "hsl(var(--haruki-leaf-deep))" }}>
            21-day free trial
          </div>
          <div className="text-sm">
            {expired
              ? "Your trial has ended. Contact your account team to continue."
              : `${daysLeft} day${daysLeft === 1 ? "" : "s"} remaining. Full access to all four training modules.`}
          </div>
        </div>
      </div>
      <div className="text-xs text-muted-foreground">
        Trial ends {end.toISOString().slice(0, 10)}
      </div>
    </div>
  );
};

export default TrialBanner;
